import { render, staticRenderFns } from "./groupArticle.edit.vue?vue&type=template&id=476806b4&scoped=true"
import script from "./groupArticle.edit.vue?vue&type=script&lang=js"
export * from "./groupArticle.edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476806b4",
  null
  
)

export default component.exports